function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 3.2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
});

const SvgCameraAlt24Px = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: 24,
  viewBox: "0 0 24 24",
  width: 24,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCameraAlt24Px, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/camera_alt-24px.04d6f20e.svg";
export { ForwardRef as ReactComponent };